import { Component, OnInit, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { GestaoPaginaService } from '../components/api/services/gestao-pagina.service';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-footer',
  imports: [RouterLink],
  providers: [GestaoPaginaService],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent implements OnInit {
  private readonly gestaoPaginaService = inject(GestaoPaginaService);
  rodape: string = '';
  anoActual: string = new Date().getFullYear().toString();

  ngOnInit(): void {
    this.loadContents();
  }

  loadContents() {
    this.rodape = this.rodape + ' ' + this.anoActual;
    forkJoin({
      // Valores
      rodape: this.gestaoPaginaService.getRodape(),
    }).subscribe((response) => {
      this.rodape = response.rodape || this.anoActual;
    });
  }
}
